import { RootState } from 'src/store/store';
import { connect } from 'react-redux';
import UILoader from 'src/components/common/loader/UILoader';

const mapStateToProps = (state: RootState) => ({
    isLoading: state.UI.isLoading
});

export default connect(mapStateToProps) (UILoader)